<template>
  <div>
    <ul class="rating-list">
      <li
        @click="setRate(rating)"
        :class="`type_${rating.value}`"
        v-for="rating in ratings"
        :key="rating.id"
      >
        <span>{{ rating.value }}</span>
      </li>
      <li @click="setRate()" class="type_add">
        <span class="icon ti-plus"></span>
      </li>
    </ul>

    <set-rating
      v-if="openRate"
      @close="openRate = false"
      v-model="rate"
      :getJournal="getJournal"
      :table="table"
      :client="client"
      :modal="`r_${table.id}_${client.id}`"
    />
  </div>
</template>

<script>
import SetRating from "./SetRating.vue";
export default {
  watch: {
    client: {
      handler: function (val) {
        this.ratings = [];
        for (let i = 0; i < this.value.length; i++) {
          if (this.value[i].timetable_id == this.table.id) {
            this.ratings.push(this.value[i]);
          }
        }
      },
      deep: true,
    },
  },
  async created() {
    for (let i = 0; i < this.value.length; i++) {
      if (this.value[i].timetable_id == this.table.id) {
        this.ratings.push(this.value[i]);
      }
    }
  },
  data() {
    return {
      rate: { value: 0, work: {} },
      ratings: [],
      openRate: false,
    };
  },
  props: ["client", "value", "table", "getJournal"],

  methods: {
    async setRate(rating = null) {
      let work = {};
      if (
        !rating &&
        this.table.lessonplan.works &&
        this.table.lessonplan.works.length
      ) {
        work = await this.table.lessonplan.works[0];
      }

      this.openRate = true;
      setTimeout(() => {
        this.rate = rating ? rating : { value: 0, work: work };
        this.$modal.show(`r_${this.table.id}_${this.client.id}`);
      }, 10);
    },
  },
  components: { SetRating },
};
</script>

<style lang="scss">
.rating-list {
  margin-left: 5px;
  display: flex;

  & > li {
    cursor: pointer;
    background: red;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    padding: 0;
    margin: 0 5px 0 0;
    width: 18px;
    height: 18px;
    max-width: 18px;
    max-height: 18px;
    min-width: 18px;
    min-height: 18px;
    border: 1px solid #999;

    &.type_add {
      background: #777;
    }

    &.type_3 {
      background: green;
    }

    &.type_4 {
      background: blue;
    }

    &.type_5 {
      background: green;
    }

    & > span {
      display: block;
      color: #fff;
      font-weight: bold;
      font-size: 12px;
    }
  }
}
</style>

